/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex, Heading, Text } from '@radix-ui/themes';

import { useArgs } from 'solis/navigation';

import AccountColonyDraftCollection from 'solis/claude/logic/account/colony.draft.collection';

import descriptor from 'solis/claude/action/descriptor/create.colony';
import ActionFooter from 'solis/claude/action/footer';

import DraftTile from 'solis/claude/welcome/draft.tile';


const getLabel = (draft) =>
{
  return draft ? 'Found ' + draft.cass.name : 'Choose a colony';
};


const Component = ({ drafts, payload, result, label }) =>
(
  <Flex direction = 'column' align = 'center' justify = 'center' gap = '6' p = '5' minHeight = '100vh'>

    <Flex direction = 'column' align = 'center' gap = '2'>
      <Heading size = '6'>Welcome to Solis</Heading>
      <Text size = '2' color = 'gray' align = 'center'>You start with a single colony. Choose the one you want to play.</Text>
    </Flex>

    <Flex wrap = 'wrap' justify = 'center' gap = '5'>
      {drafts.map(draft => <DraftTile key = {draft.cass.id} draft = {draft} />)}
    </Flex>

    <ActionFooter type = {descriptor.type} args = {payload} valid = {result.valid} issues = {result.issues} label = {label} />

  </Flex>
);


export default ({ account }) =>
{
  const raw = useArgs(Object.keys(descriptor.inputs), descriptor.scope);

  const args = Object.fromEntries(Object.entries(descriptor.inputs).map(([ name, fallback ]) =>
  {
    return [ name, raw[name] ?? fallback ];
  }));

  const context = { account, args };

  const drafts = new AccountColonyDraftCollection(account).getInitialColonyDrafts();

  const label = getLabel(drafts.find(draft => draft.cass.id === args.draft));

  return <Component drafts = {drafts} payload = {descriptor.buildArgs(context)} result = {descriptor.validate(context)} label = {label} />;
};
